import { render, staticRenderFns } from "./MoralEducationRecord.vue?vue&type=template&id=5e725a1e&scoped=true&"
import script from "./MoralEducationRecord.vue?vue&type=script&lang=js&"
export * from "./MoralEducationRecord.vue?vue&type=script&lang=js&"
import style0 from "./MoralEducationRecord.vue?vue&type=style&index=0&id=5e725a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e725a1e",
  null
  
)

export default component.exports